import { CheckIcon } from '@chakra-ui/icons';
import { Flex, Icon, Image, useBoolean, VStack, Text, useMediaQuery } from '@chakra-ui/react';
import {
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepSeparator,
} from '@chakra-ui/stepper';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import keyboardReturn from 'assets/enter_button_icon.png';
import {
  clearStepperFormData,
  getFormValues,
  getMetaDataFile,
  setActionCreateForm,
  setClearSelectedAreasTable,
  stepsLength,
} from 'redux/DataImportSlice';

import HelpImportModal from '../HelpImportModal';

import ActionStepOne from './ActionStepOne';
import ActionStepThree from './ActionStepThree';
import ActionStepTwo from './ActionStepTwo';
import ActionStepSyncOptions from './ActionStepSyncOptions';
import DataStepsForm from './DataSteps/DataStepsForm';

const ActionCreateForm = ({ setactionCreate }: any) => {
  const dispatch: any = useDispatch();
  const [isMobile] = useMediaQuery('(max-width: 1610px)');
  const { modelId } = useParams();
  const [helpModalSeleceted, setHelpModalSeleceted] = useBoolean(false);
  const getFormValue = useSelector(getFormValues);
  const [steps, setSteps] = useState([1, 2, 3]);
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);

  useEffect(() => {
    dispatch(getMetaDataFile(modelId));
  }, [modelId]);

  useEffect(() => {
    if (getFormValue.dataType === '1') {
      // Dimension imports always have 4 steps: name → target → properties → removal config
      setSteps([1, 2, 3, 4]);
    }
  }, [getFormValue.dataType === '1', activeActionStep]);

  useEffect(() => {
    if (getFormValue.dataType === '2' || getFormValue.dataType === '3') {
      setSteps([1, 2, 3, 4, 5, 6]);
    }
  }, [getFormValue.dataType, activeActionStep]);
  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1'
    ) {
      setSteps([1, 2, 3, 4, 5, 6]);
    }
  }, [getFormValue.dataType, getFormValue?.dataPeriod, activeActionStep]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [getFormValue.dataType, getFormValue?.dataPeriod, activeActionStep]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      (getFormValue?.selectedTimePeriod === 'row' || getFormValue?.selectedTimePeriod === 'column')
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    activeActionStep,
    getFormValue.selectedTimePeriod,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1' &&
      getFormValue?.multipleIndicatorsType === 'column' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.selectedTimePeriod === 'row' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.selectedTimePeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);
  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.selectedTimePeriod === 'column' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.selectedTimePeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.multipleIndicatorsType === 'column' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    dispatch(stepsLength(steps.length));
  }, [steps]);

  return (
    <Flex flexDirection={'column'}>
      <Flex
        align={'center'}
        gap={3}
        height={'22px'}
        pb={2}
        position='relative'
        zIndex={1}
        cursor='pointer'
        onClick={async () => {
          setactionCreate?.(false);
          await dispatch(setActionCreateForm(false));
          await dispatch(clearStepperFormData());
          await dispatch(setClearSelectedAreasTable());
        }}
      >
        <Image src={keyboardReturn} height={8} width={8} mt={'3px'} pointerEvents='none' />
        <Text fontSize={'sm'} textAlign={'start'} pointerEvents='none'>
          Action
        </Text>
      </Flex>
      <Flex
        width={'fit-content'}
        align={steps.length > 3 ? 'start' : 'center'}
        pt={3}
        pb={5}
        flexDirection={steps.length > 3 && isMobile ? 'column' : 'row'}
      >
        <Text me={3} mb={1}>
          Step {activeActionStep + 1}
        </Text>
        <Stepper display={'flex'} index={activeActionStep} color={'white'}>
          {steps.map((step, index) => (
            <Step key={index}>
              <Flex display='flex' alignItems='center' mt={'2px'}>
                <StepIndicator
                  bgColor={'#4BB6B9'}
                  borderRadius={'50%'}
                  height={'21px'}
                  width={'22px'}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <StepStatus
                    complete={<StepIcon width={'1rem'} height={'1rem'} />}
                    incomplete={
                      <Icon
                        viewBox='0 0 200 200'
                        color='white'
                        border='1px solid #9C9BBD'
                        borderRadius='50%'
                        height={'21px'}
                        width={'22px'}
                      >
                        <path fill='#fff' d='M0,0 L0,200 L200,200 L200,0 Z' />
                      </Icon>
                    }
                    active={<CheckIcon width={'0.8rem'} height={'0.8rem'} />}
                  />
                </StepIndicator>
                {index !== steps.length - 1 && (
                  <StepSeparator>
                    <Flex
                      // style={{
                      border='1px solid #9C9BBD'
                      width={activeActionStep > 4 ? '20px' : '30px'}
                      height='1px'
                      color='black'
                      // {/* }} */ }
                    />
                  </StepSeparator>
                )}
              </Flex>
            </Step>
          ))}
        </Stepper>
      </Flex>
      <Flex flexDirection={'column'}>
        <VStack
          w={'full'}
          pt={5}
          px={7}
          pb={5}
          minH={'320px'}
          align={'stretch'}
          bg={'white'}
          mt={2}
          borderRadius={'11px'}
        >
          {/* <Flex justifyContent={'space-between'} w={'full'} align={'center'}>
            <Text
              color={'#6562CF'}
              fontSize='lg'
              fontFamily={'regular_roboto'}
              fontWeight={'400'}
              textAlign={'start'}
            >
              {activeActionStep === 0
                ? 'Name your action'
                : activeActionStep === 1
                ? 'Select data type'
                : 'Select properties'}
            </Text>
            <CloseIcon
              color={'black'}
              width={3}
              height={3}
              cursor={'pointer'}
              onClick={async () => {
                setactionCreate(false);
                await dispatch(setActionCreateForm(false));
                await dispatch(clearStepperFormData());
                await dispatch(setClearSelectedAreasTable());
              }}
            />
          </Flex> */}

          {activeActionStep === 0 ? (
            <ActionStepOne
              setHelpModalSeleceted={setHelpModalSeleceted}
              setactionCreate={setactionCreate}
            />
          ) : activeActionStep === 1 ? (
            <ActionStepTwo setHelpModalSeleceted={setHelpModalSeleceted} />
          ) : getFormValue?.dataType === '1' && activeActionStep === 2 ? (
            // Step 3 (dimension): map file columns to dimension properties
            <ActionStepThree setHelpModalSeleceted={setHelpModalSeleceted} />
          ) : getFormValue?.dataType === '1' && activeActionStep === 3 ? (
            // Step 4 (dimension): sync options — remove missing items config, then run
            <ActionStepSyncOptions
              actionType='dimension'
              setHelpModalSeleceted={setHelpModalSeleceted}
            />
          ) : (
            <DataStepsForm setHelpModalSeleceted={setHelpModalSeleceted} />
          )}
        </VStack>
        <HelpImportModal
          setHelpModalSeleceted={setHelpModalSeleceted}
          helpModalSeleceted={helpModalSeleceted}
        />
      </Flex>
    </Flex>
  );
};

export default ActionCreateForm;
